import React, { Component } from 'react'
import { withFormik, Form, Field } from 'formik'
import { Link } from 'react-router-dom'
import { updateProfile } from '../utils/authService';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string'
import { createHashHistory } from 'history'
import PhoneNumberField from './PhoneNumberField'

const history = createHashHistory();

const validate = (values, props) => {
  let errors = {};

  if (!values.firstName) {
    errors.firstName = props.t('enterFirstName');
  }
  if (!values.lastName) {
    errors.lastName = props.t('enterLastName');
  }
  if (!values.email) {
    errors.email = props.t('emailRequired');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
    errors.email = props.t('invalidEmail');
  }

  if (!values.userName) {
    errors.userName = props.t('enterUserName');
  }

  if (values.phone.trim().length > 0) {
    let digits = values.phone.replace(/[^0-9]/gi, '')

    if (!/[0-9]{10}/.test(digits)) {
      errors.phone = props.t('invalidPhone')
    }
  }

  return errors;
};

const styles = {
  display: 'none',
}


class ProfileComponent extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      isEditing: false,
      cbUrl : '' 
    }
  }

  componentDidMount() {
    const { accessToken } = this.props;
    const { givenName, familyName, email, userName, phone, id } = this.props.userProfile;
    const { search, hash } = this.props.location;

    if(search && hash) {
      let _queryString = queryString.parse(search);
      if(_queryString.callback) {
        this.setState({cbUrl: _queryString.callback + hash})
      }
    }

    if (!givenName || !familyName || !email || !userName || !phone || !id) {
      this.props.getUserProfile(accessToken);
    }

    document.title = `City of Seattle | ${this.props.t('profile')}`
  }
  render() {

    const {
      values,
      handleChange,
      setFieldValue,
      setFieldTouched,
      dirty,
      errors,
      t,
      touched,
      isSubmitting
    } = this.props

    const handleClick = (e) => {
      e.preventDefault()
      //re-route back to ePortal profile page when Cancel button is clicked
      if (window.location.hash.indexOf('callback') > 0) {
        const callbackurl = window.location.hash.split('callback=');
        window.location = callbackurl[1];
     }
      else {
        history.push('/apps');
      }
    }
      function getParameterByName(name, url = window.location.href) {
          name = name.replace(/[\[\]]/g, '\\$&');
          var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }

      values.appName = getParameterByName('appName');

    return (
      <div>
        <h2>{t('profile')}</h2>
        <Form className="App-form">
        <div className={"form-group form-group-lg " + (errors.userName && touched.userName ? 'has-error' : '')}>
            <label htmlFor="userName" className="control-label">{t('userName')} <span className="text-danger">*</span></label>
            <Field type="userName" className="form-control" name="userName" value={values.userName} maxLength="20" onChange={handleChange} disabled/>
            {errors.userName && touched.userName && <div className="text-danger exception-margin" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span className="sr-only">Error:</span>
              {touched.userName && errors.userName}
            </div>}
          </div>
          <div
            className={"form-group form-group-lg " + (errors.firstName && touched.firstName
              ? 'has-error'
              : '')}>
            <label htmlFor="firstName" className="control-label">{t('firstName')}
              <span className="text-danger">*</span>
            </label>
            <Field
              type="firstName"
              className="form-control"
              name="firstName"
              value={values.firstName}
              maxLength="20"
              onChange={handleChange} /> {errors.firstName && touched.firstName && <div className="text-danger exception-margin" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                <span className="sr-only">Error:</span>
                {touched.firstName && errors.firstName}
              </div>}
          </div>
          <div
            className={"form-group form-group-lg " + (errors.lastName && touched.lastName
              ? 'has-error'
              : '')}>
            <label htmlFor="lastName" className="control-label">{t('lastName')}
              <span className="text-danger">*</span>
            </label>
            <Field
              type="lastName"
              className="form-control"
              name="lastName"
              value={values.lastName}
              maxLength="20"
              onChange={handleChange} /> {errors.lastName && touched.lastName && <div className="text-danger exception-margin" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                <span className="sr-only">Error:</span>
                {touched.lastName && errors.lastName}
              </div>}
          </div>
          <div
            className={"form-group form-group-lg " + (errors.email && touched.email
              ? 'has-error'
              : '')}>
            <label htmlFor="email" className="control-label">{t('email')}
              <span className="text-danger">*</span>
            </label>
            <Field
              type="email"
              aria-describedby="emailAddressHelpBlock"
              className="form-control"
              name="email"
              maxLength="50"
              placeholder={t('placeholdEmail')}
              value={values.email}
              onChange={handleChange} /> {errors.email && touched.email && <div className="text-danger exception-margin" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                <span className="sr-only">Error:</span>
                {touched.email && errors.email}
              </div>}
          </div>
          <div className={"form-group form-group-lg " + (errors.phone && touched.phone ? 'has-error' : '')}>
            <label htmlFor="phone" className="control-label">{t('phone')} <span className="text-danger"></span></label>
            <PhoneNumberField phone={values.phone} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched} />
            {errors.phone && touched.phone && <div className="text-danger exception-margin" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span className="sr-only">Error:</span>
              {touched.phone && errors.phone}
            </div>}
          </div>
          <div style={styles}>
            <Field name="id" value={values.id} />
          </div>

          <button type="button" className="btn btn-secondary btn-lg" onClick={handleClick} >{t('cancel')}</button>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={!dirty || isSubmitting}>{t('save')}</button>
        </Form>
        <div className="return-link">
        <Link to={`/password-new?callback=${this.state.cbUrl}`}>{t('updatePassword')}</Link>
      </div>
      </div>
    )
  }
}

const Profile = withFormik({
  isInitialValid: true,
  mapPropsToValues({ userProfile }) {
    const { givenName, familyName, email, userName, phone, id } = userProfile;
    return {
      firstName: givenName || '',
      lastName: familyName || '',
      email: email || '',
      userName: userName || '',
      phone: phone || '',
      id: id
    }
  },
  validate: validate,
  handleSubmit(values, { props, setSubmitting }) {
    const { email, firstName, lastName, userName, phone, id, appName } = values;
    const digits = phone.replace(/[^0-9]/gi, '')
    const credentials = {
      username: userName,
      givenName: firstName,
      familyName: lastName,
      email: email,
      phone: digits,
      id: id,
      appName: appName
    };
    updateProfile(credentials, props.accessToken)
      .then(response => {
        const params = queryString.parse(props.location.search)
        const hash = props.location.hash
        
        if (params.callback) {
          window.location = params.callback + hash
        } else {
          props.getUserProfile(props.accessToken);
          props.showNotification({ type: 'success', title: props.t('profileSuccessTitle'), message: props.t('profileSuccess') });
        }
      })
      .catch(error => {
        props.showNotification({ type: 'failure', title: props.t('profileFailedTitle'), message: props.t('profileFailed') });
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
  enableReinitialize: true
})(ProfileComponent)

export default withTranslation()(Profile);
